module.exports = __webpack_public_path__ + "img/neu-laden-aktiv.8eb46f50.svg";